import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { GlobalVariable } from '../global';
import { DataService } from '../services/dataService/data.service';
import { UserApiService } from '../services/user-api.service';
import { AppSelectionOptions, LaunchNavigator, LaunchNavigatorOptions, RememberChoiceOptions } from '@awesome-cordova-plugins/launch-navigator/ngx';
// import {MatAccordion} from '@angular/material/expansion';
@Component({
  selector: 'app-business-details',
  templateUrl: './business-details.page.html',
  styleUrls: ['./business-details.page.scss'],
})
export class BusinessDetailsPage implements OnInit {
  showTimings = false;
  showPickTimings = false;
  showDelTimings = false;
  showAbout = false;
  // days=['monday', 'tuesday','wed','monday', 'tuesday','wed','d']
  businessDetail: any;
  bannerData: any;
  Offers=[];
isDataLoaded=false;

  // resTimingsMon: any;
  // resTimingsTue: any;
  // resTimingsWed: any;
  // resTimingsThu: any;
  // resTimingsFri: any;
  // resTimingsSat: any;
  // resTimingsSun: any;
  // timings=[
  //   {day:'Monday',openTime:'7:30', closeTime:'3:00',isOpen:'0',text:'ddd'},
  //   {day:'Tuesday',openTime:'7:30', closeTime:'3:00',isOpen:'1',text:' Special Discounts'},
  //   {day:'Wednesday',openTime:'7:30', closeTime:'3:00',isOpen:'1',text:'Special Discounts'},
  //   {day:'Thursday',openTime:'7:30', closeTime:'3:00',isOpen:'1',text:' Special Discounts'},
  //   {day:'Friday',openTime:'7:30', closeTime:'3:00',isOpen:'0',text:'Discounts'},
  //   {day:'Saturday',openTime:'7:30', closeTime:'3:00',isOpen:'1',text:' Special Discounts'},
  //   {day:'Saturday',openTime:'7:30', closeTime:'3:00',isOpen:'0',text:' Special Discounts'},
  // ]
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    // private dataService: DataService,
 
    public globals:GlobalVariable,
    public server:UserApiService,
    private launchNavigator: LaunchNavigator,

  ) {
    //data from getplaces api
    // this.businessDetail=this.globals.businessData;
    this.getBusiness()
  }
  getBusiness(){
    this.globals.loader();
    this.server.getBusiness('','main').subscribe(res=>{
      this.globals.dismiss();
      if(res.status){
       this.businessDetail=res.results[0]
      }
    },err=>{
      this.globals.dismiss();

    })
  }

  ngOnInit() {
    // if (this.route.snapshot.data['businessDetail']) {
    //   this.businessDetail = this.route.snapshot.data['businessDetail'];
    //   console.log('Detail', this.businessDetail);

    // }
  }
  ionViewWillEnter() {
    console.log('business Detail Entered');
  this.special_offer_banners();
    
  }

  navigateTo(){
    // this.launchNavigator.appSelection
    let rememberChoice : RememberChoiceOptions={
      enabled:false,
    }
    let appSelection: AppSelectionOptions = {
      list: [
        this.launchNavigator.APP.GOOGLE_MAPS,
        this.launchNavigator.APP.WAZE,
        this.launchNavigator.APP.APPLE_MAPS,
        this.launchNavigator.APP.YANDEX,
        this.launchNavigator.APP.CITYMAPPER
      ],
      rememberChoice:rememberChoice,
    }
  
    let options: LaunchNavigatorOptions = {
      // start: this.globals.address,
      appSelection: appSelection,
      
      
    };
    if(this.businessDetail.address){
    
      this.launchNavigator.navigate(this.businessDetail.address, options)
      .then(
        success => {
          // this.launchNavigator.appSelection.userChoice.clear(()=>{
          //   console.log("User preferred app is cleared");
        // });
          console.log(success,'Launched navigator')},
        error => {
        //   this.launchNavigator.appSelection.userChoice.clear(()=>{
        //     console.log("User preferred app is cleared");
        // });
          this.globals.presentToast("Failed to navigate")
          console.log('Error launching navigator', error)}
      );
    }
    // this will clear user selection..... will add to settings later.
  
   
  }

  // openLocation(resData) {
  //   jj
  //   // this.storage.set('resData', resData);
  //   // this.router.navigate(['/business-location']);
  // }
  openMenu(resData) {
    // this.dataService.setData(resData.business_id, resData);
    // this.router.navigateByUrl('/order');
    // this.storage.set('resData', resData);
    this.router.navigate(['/order']);
  }
  showResTimings() {
    if (this.showTimings == false) {
      this.showTimings = true;
      this.showPickTimings = false;
      this.showDelTimings = false;
    } else {
      this.showTimings = false;
    }
  }
  showResPickTimings() {
    if (this.showPickTimings == false) {
      this.showPickTimings = true;
      this.showTimings = false;
      this.showDelTimings = false;
    } else {
      this.showPickTimings = false;
    }
  }
  showResDelTimings() {
    if (this.showDelTimings == false) {
      this.showDelTimings = true;
      this.showPickTimings = false;
      this.showTimings = false;
    } else {
      this.showDelTimings = false;
    }
  }
  showResAbout() {
    if (this.showAbout == false) {
      this.showAbout = true;
      this.showTimings = false;
      this.showDelTimings = false;
      this.showPickTimings = false;
    } else {
      this.showAbout = false;
    }
  }
  goToGallery(data) {
    // this.storage.set('resData', data);
    this.router.navigate(['/gallery']);
  }
  goToReviews(data) {
    // this.storage.set('resData', data);
    this.router.navigate(['/reviews']);
  }
   openCart() {
    // this.modalController.dismiss();
    this.router.navigate(['/new-cart']);
  }
  special_offer_banners(){
    this.isDataLoaded=false;
    let response = this.server.special_offer_banners();
    response.subscribe(data => {
    this.isDataLoaded=true;
       
      console.log('offers data ',data)
      this.bannerData = data;
      this.Offers = this.bannerData.data;
      console.log('offers data ',this.Offers)

    }, error => {
        console.log(error);
 this.globals.presentToast("Something went wrong, try again");
 
    });
}
}
